import { z } from "zod"

export const updateSchema = z.object({
  full_name: z.string().min(3, { message: 'Tamanho minimo: 3 caracteres' }).max(64, { message: 'Tamanho máximo: 64 caracteres' }),
  phone: z.string().min(3, { message: 'Tamanho minimo: 3 caracteres' }).max(64, { message: 'Tamanho máximo: 64 caracteres' }),
})

export type TmaisUsersValidationSchema = z.infer<typeof updateSchema>
